export const SUPPORTED_LANGUAGES = ['en', 'ru', 'es', 'fr', 'pt'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LOCALE_STORAGE_KEY = 'paygatex-lk-locale';
export const LOCALE_QUERY_KEY = 'lang';

/** Same cookie as the landing (`paygatex/src/lib/shared-locale.ts`). */
export const SHARED_LOCALE_COOKIE = 'paygatex_locale';
export const SHARED_LOCALE_COOKIE_DOMAIN = '.paygatex.io';

export const isSupportedLanguage = (value: string | null): value is SupportedLanguage =>
  Boolean(value && (SUPPORTED_LANGUAGES as readonly string[]).includes(value));
